import React from 'react';
import AccountLayout from '@layouts/student/AccountLayout';
import InnerContainer from '@components/Container';
import { Outlet } from 'react-router-dom';
import { Container } from 'geniebook-ui/dist';
import { useIsJCUser } from '@hooks/user.hook';

const AccountRouteLayout = () => {
  const { isJC } = useIsJCUser({ subjectId: undefined, generalPage: true });
  return (
    <Container>
      <AccountLayout className="mt-8">
        <InnerContainer
          className={`before:content-[' '] before:-z-10 before:bg-cover before:bg-fixed before:bg-no-repeat before:bg-primary-navyblue-dark before:bg-[6.5%_41%] ${
            isJC === false
              ? "before:bg-[url('/public/img/Background_Default_1.svg')]"
              : ''
          } before:fixed before:h-[calc(100%+76px)] before:left-0 before:top-16 before:w-screen before:max-lg:top-12 before:max-md:h-[calc(100%+68px)] text-white badges-page max-lg:pb-24 lg:pb-0 max-md:w-full lg:h-[calc(100vh-96px)] lg:overflow-y-auto !overflow-x-visible no-scrollbar relative !w-full lg:px-[8.33%]`}
        >
          <Outlet />
        </InnerContainer>
      </AccountLayout>
    </Container>
  );
};

export default AccountRouteLayout;
